<template>
    <button
        class="c-button-wrapper btn"
        :class="`btn-${btnVariant} btn-${size}`"
        :type="type"
        :disabled="disabled"
        @click="(e) => emit('click', e)"
    >
        <template v-if="!slots.default">
            <font-awesome-icon v-if="icon" :icon="icon" :class="{ 'mr-2': text && text.length }" />
            {{ text }}
        </template>
        <slot />
    </button>
</template>

<script setup lang="ts">
import { computed, useSlots } from 'vue';
import type { CButtonVariant } from '.';

const props = withDefaults(
    defineProps<{
        text?: string;
        icon?: string | string[];
        size?: string;
        variant?: CButtonVariant;
        disabled?: boolean;
        type?: 'button' | 'submit';
    }>(),
    { type: 'button', size: 'md' }
);

const emit = defineEmits<{
    (event: 'click', e: MouseEvent): void;
}>();

const slots = useSlots();

const btnVariant = computed(() => (props.variant?.length ? props.variant : 'empty'));
</script>

<style lang="scss" scoped>
@import '@/assets/css/utilities/functions';
.c-button-wrapper {
    font-weight: normal;
    &.btn,
    &:focus,
    &:hover {
        box-shadow: none !important;
    }
    &.btn-empty:hover,
    &.btn-outline-empty:hover {
        background-color: get-color('gray-200');
    }
    &.btn-outline-empty {
        border: 1px solid get-color('gray-light');
    }
    &.btn-icon {
        height: 21px;
        box-sizing: content-box;
        font-size: 0.875rem;
    }
}
</style>
